import * as echarts from "echarts";

export const mileChartOptions = {
  tooltip: {
    trigger: "axis",
    axisPointer: {
      // 坐标轴指示器，坐标轴触发有效
      type: "shadow" // 默认为直线，可选为：'line' | 'shadow'
    }
  },
  grid: {
    left: "2%",
    right: "4%",
    bottom: "0",
    top: "20%",
    containLabel: true
  },
  legend: {
    data: ["班线", "包车", "客运"],
    icon: "roundRect",
    top: "0%",
    right: "1%",
    textStyle: {
      color: "#f9f9f9"
    },
    itemWidth: 10,
    itemHeight: 10
  },
  xAxis: {
    type: "category",
    data: [
      "1月",
      "2月",
      "3月",
      "4月",
      "5月",
      "6月",
      "7月",
      "8月",
      "9月",
      "10月",
      "11月",
      "12月"
    ],
    axisLine: {
      show: true,
      lineStyle: {
        color: "#222e54"
      }
    },
    axisTick: {
      show: false,
      alignWithLabel: true
    },
    axisLabel: {
      color: "#a9d8ff",
      textStyle: {
        fontSize: 14
      }
    }
  },
  yAxis: {
    name: "单位:公里",
    nameTextStyle: {
      color: "#a9d8ff",
      fontSize: 13
    },
    type: "value",
    axisLine: {
      lineStyle: {
        color: "#222e54"
      }
    },
    splitLine: {
      show: false,
      lineStyle: {
        color: "#f1f1f1"
      }
    },
    axisLabel: {
      color: "#a9d8ff",
      textStyle: {
        fontSize: 13
      }
    },
    axisTick: {
      show: false,
      alignWithLabel: true
    }
  },
  series: [
    {
      name: "班线",
      type: "bar",
      barWidth: "10",
      itemStyle: {
        normal: {
          color: "#33e8fb",
          barBorderRadius: [2, 2, 0, 0]
        }
      },
      data: [400, 400, 300, 300, 300, 400, 400, 400, 300]
    },
    {
      name: "包车",
      type: "bar",
      barWidth: "10",
      itemStyle: {
        normal: {
          color: "#28daac",
          barBorderRadius: [2, 2, 0, 0]
        }
      },
      data: [400, 500, 500, 500, 500, 400, 400, 500, 500]
    },
    {
      name: "客运",
      type: "bar",
      barWidth: "10",
      itemStyle: {
        normal: {
          color: "#f0bf3d",
          barBorderRadius: [2, 2, 0, 0]
        }
      },
      data: [400, 600, 700, 700, 1000, 400, 400, 600, 700]
    }
  ]
};

export const countOptions = {
  tooltip: {
    trigger: "axis"
  },
  legend: {
    data: ["班车", "包车", "客运"],
    textStyle: {
      fontSize: 12,
      color: "rgb(0,253,255,0.6)",
      padding: [0, -30, 0, 0]
    },
    right: "0%",
    top: "1%"
  },
  grid: {
    left: "5%",
    right: "3%",
    bottom: "0",
    top: "15%",
    containLabel: true
  },
  xAxis: {
    type: "category",
    boundaryGap: false,
    data: [
      "1月",
      "2月",
      "3月",
      "4月",
      "5月",
      "6月",
      "7月",
      "8月",
      "9月",
      "10月",
      "11月",
      "12月"
    ],
    axisLine: {
      show: true,
      lineStyle: {
        color: "#222e54"
      }
    },
    axisLabel: {
      textStyle: {
        color: "rgb(0,253,255,0.6)"
      },
      formatter: function(params) {
        return params.split(" ")[0];
      }
    }
  },
  yAxis: {
    name: "次数",
    nameTextStyle: {
      color: "#a9d8ff",
      fontSize: 13
    },
    type: "value",
    axisLabel: {
      textStyle: {
        color: "#a9d8ff"
      }
    },
    splitLine: {
      show: false,
      lineStyle: {
        color: "rgb(23,255,243,0.3)"
      }
    },
    axisLine: {
      lineStyle: {
        color: "#222e54"
      }
    }
  },
  series: [
    {
      name: "班车",
      type: "line",
      color: "rgba(52, 236, 252,1)",
      smooth: true,
      areaStyle: {
        normal: {
          color: new echarts.graphic.LinearGradient(
            0,
            0,
            0,
            1,
            [
              {
                offset: 0,
                color: "rgba(52, 236, 252,1)"
              },
              {
                offset: 0.8,
                color: "rgba(52, 236, 252,0.1)"
              }
            ],
            false
          ),
          shadowColor: "rgba(0, 0, 0, 0.1)",
          shadowBlur: 10
        }
      },
      symbol: "circle",
      symbolSize: 5,
      data: [30, 52, 30, 53, 95, 23, 17]
    },
    {
      name: "包车",
      type: "line",
      color: "rgba(39, 215, 172,1)",
      smooth: true,
      areaStyle: {
        normal: {
          color: new echarts.graphic.LinearGradient(
            0,
            0,
            0,
            1,
            [
              {
                offset: 0,
                color: "rgba(39, 215, 172,1)"
              },
              {
                offset: 0.8,
                color: "rgba(39, 215, 172,0.1)"
              }
            ],
            false
          ),
          shadowColor: "rgba(0, 0, 0, 0.1)",
          shadowBlur: 10
        }
      },
      symbol: "circle",
      symbolSize: 5,
      data: [36, 45, 80, 62, 33, 80, 92]
    },
    {
      name: "客运",
      type: "line",
      color: "rgba(241, 193, 66,1)",
      smooth: true,
      areaStyle: {
        normal: {
          color: new echarts.graphic.LinearGradient(
            0,
            0,
            0,
            1,
            [
              {
                offset: 0,
                color: "rgba(241, 193, 66,1)"
              },
              {
                offset: 0.8,
                color: "rgba(241, 193, 66,0.1)"
              }
            ],
            false
          ),
          shadowColor: "rgba(0, 0, 0, 0.1)",
          shadowBlur: 10
        }
      },
      symbol: "circle",
      symbolSize: 5,
      data: [22, 25, 80, 92, 40, 18, 22]
    }
  ]
};
